import D from "@/assets/img/icons/groups/D.svg";
import Price from "@/assets/img/icons/price.svg";
import ID from "@/assets/img/icons/id.svg";
import Clock from "@/assets/img/icons/clock.svg";
import Document from "@/assets/img/icons/document.svg";
import Doctor from "@/assets/img/icons/doctor.svg";
import Location from "@/assets/img/icons/location.svg";
import Cross from "@/assets/img/icons/cross.svg";
import B from "@/assets/img/icons/groups/B.svg";
import C from "@/assets/img/icons/groups/C.svg";

import Bus from "@/assets/img/groups/d/bus.webp";

export default {
    title: "Autobus",
    subtitle: "od 21 let",
    image: D,
    headingImage: Bus,
    route: 'd',
    pageTitle: "Skupina D",
    whatCanIDrive: [
        "Motorová vozidla s více než 8 místy k sezení kromě místa řidiče, ke kterým smí být připojeno přípojné vozidlo o největší povolené hmotnosti nepřevyšující 750 kg"
    ],
    heading: [
        {
            icon: Price,
            title: "Cena",
            body: "od 45 000 Kč"
        },
        {
            icon: ID,
            title: "Věk",
            body: "24 let (21/23 let za níže uvedených podmínek)",
        },
        {
            icon: ID,
            title: "Oprávnění",
            body: "Opravňuje k řízení autobusů i s přívěsem o maximální hmotnosti 750 kg"
        },
        {
            icon: Clock,
            title: "Rozsah výcviku",
            body: "38 hodin teorie a 20 hodin praxe"
        }
    ],
    conditions: [
        {
            icon: ID,
            text: '<b>Řidičské oprávnění pro skupinu D můžete získat už v 21 letech, s omezením pouze k řízení vozidel:</b><br>' +
                'a) Ministerstva vnitra používaných policií,<br>' +
                'b) Vězeňské služby České republiky,<br>' +
                'c) ozbrojených sil České republiky,<br>' +
                'd) obecní policie,<br>' +
                'e) Hasičského záchranného sboru České republiky a jednotek požární ochrany,<br>' +
                'f) celních orgánů,<br>' +
                'g) při zkušební jízdě v souvislosti s jejich opravou nebo údržbou<br>' +
                '<br>' +
                'Po dosažení věku 24 let toto omezení pozbývá platnosti.<br>'
        },
        {
            icon: ID,
            text: '<b>Řidičské oprávnění pro skupiny D lze udělit rovněž osobě, která dosáhla věku 21 let nebo 23 let. Toto řidičské oprávnění opravňuje do dosažení věku 24 let jeho držitele k řízení:</b><br>' +
                'a) za účelem řízení v rámci vstupního školení na profesní osvědčení (profesní způsobilost),<br>' +
                'b) pokud je držitelem profesního osvědčení (dnes profesní způsobilost) a podrobil se vstupnímu školení: <br>' +
                '- v rozšířeném rozsahu 280 hodin (od 21 let), nebo<br>' +
                '- v základním rozsahu 140 hodin (od 23 let), nebo řídí-li vozidlo linkové osobní dopravy a trasa linky nepřesahuje 50 km (od 21 let).'
        },
        {
            icon: Document,
            text: 'vyplněná a podepsaná Přihláška do výcviku'
        },
        {
            icon: Document,
            text: 'odborná způsobilost'
        },
        {
            icon: Doctor,
            text: 'psychologické vyšetření'
        },
        {
            icon: Doctor,
            text: 'platný lékařský posudek potvrzený praktickým lékařem'
        },
        {
            icon: Location,
            text: 'trvalý nebo přechodný pobyt v ČR'
        },
        {
            icon: Cross,
            text: 'nebýt ve výkonu sankce nebo trestu zákazu řízení'
        },
    ],
    extensions: [
        {
            fromGroup: B,
            length: "individuální",
            age: "od 21 let",
            price: "32 000 Kč"
        },
        {
            fromGroup: C,
            length: "individuální",
            age: "od 21 let",
            price: "od 20 000 Kč"
        },
    ],
    gallery: [
        {
            image: Bus,
            alt: ""
        }
    ],
}